import * as API from "./api";
import * as Dialog from "./dialog";
import { getUITranslation } from "../utils/get_ui_translation";

document.addEventListener("click", async (event) => {
  const confirmDeleteEl = event.target.closest("[data-confirm-delete]");
  if (!confirmDeleteEl) return;

  event.preventDefault();
  event.stopPropagation();
  const isOk = await Dialog.okCancel(getUITranslation("Attention"), confirmDeleteEl.dataset.confirmDelete);
  if (!isOk) return;

  submitElement(confirmDeleteEl);
});

export function submitElement(el) {
  if (el.tagName == "A") {
    const method = el.dataset.method || "get";
    const url = el.dataset.to;
    const csrfToken = API.getCSRFToken();

    const formEl = document.createElement("form");
    formEl.method = "post";
    formEl.action = url;
    formEl.insertAdjacentHTML(
      "beforeend",
      `<input type="hidden" name="_csrf_token" value="${csrfToken}"/>
       <input type="hidden" name="_method" value="${method}" />`
    );

    el.insertAdjacentElement("afterend", formEl);

    formEl.submit();
  } else {
    el.closest("form").submit();
  }
}
